<ngx-spinner></ngx-spinner>
<app-header></app-header>
<div class="wrapper">
  <div class="container">
    <div class="row mt-4 pb-4">
      <div class="col-12 text-center">
        <h2 class="manage-profile-heading">
          {{ "EDIT_PROFILE.EDIT_PROFILE" | translate }}
        </h2>
        <ul class="profile-user-list manage-profile-sect mb-0">
          <li>
            <a href="javascript:void(0)">
              <span *ngIf="model?.id == userInfo?.people_profile[0]?.id">
                <span *ngIf="userInfo.image" class="circle min-profile d-block">
                  <img src="{{ userInfo.image }}" class="w-100"
                /></span>

                <span
                  *ngIf="!userInfo.image"
                  class="manage-profile icon-bg-yellow"
                >
                  <img src="assets/images/user-icon.png" class="w-100" />
                </span>
              </span>
              <span
                *ngIf="model?.id != userInfo?.people_profile[0]?.id"
                class="manage-profile icon-bg-{{ model?.color }}"
              >
                <img src="assets/images/user-icon.png" class="w-100" />
              </span>
            </a>
          </li>
        </ul>
        <form
          class="manage-profile-from"
          (ngSubmit)="onSubmit(editForm)"
          #editForm="ngForm"
        >
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              placeholder="Enter Name"
              [(ngModel)]="model.name"
              #name="ngModel"
              name="name"
            />
          </div>
          <div class="pt-3 pb-3">
            <button
              class="btn btn-cancel mr-3"
              type="button"
              [routerLink]="['/manage-profile/watch']"
            >
              {{ "EDIT_PROFILE.CANCEL" | translate }}
            </button>
            <button class="btn btn-theme" type="submit" [disabled]="btnDisable">
              <span class="spin icon-loader" *ngIf="isLoading"> </span>
              {{ "EDIT_PROFILE.SAVE_CHANGES" | translate }}
            </button>
          </div>
          <a
            href="javascript:void(0)"
            class="orange-link"
            (click)="removeProfile()"
          >
            {{ "EDIT_PROFILE.REMOVE_PROFILE" | translate }}
          </a>
        </form>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
